// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"277":"style/ui5-theming","9370":"style/app"}[chunkId] + ".css";
};